import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import ServicesSection from "./components/ServicesSection";
import LocalitiesSection from "./components/LocalitiesSection";
import AboutSection from "./components/AboutSection";
import CtaSection from "./components/CtaSection";
import FaqSection from "./components/FaqSection";
import SeoHead from "@/components/SeoHead";

const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "Carreaux-Bat Valais",
  "image": "/images/logo.png",
  "url": "https://carreaux-bat.ch",
  "telephone": "+41 77 511 75 52",
  "email": "info@carreaux-bat.ch",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Rue de Pramagnon 32",
    "addressLocality": "Grône",
    "addressRegion": "Valais",
    "postalCode": "3979",
    "addressCountry": "CH"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": 46.2304,
    "longitude": 7.4381
  },
  "openingHoursSpecification": [
    {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      "opens": "07:00",
      "closes": "18:00"
    },
    {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": "Saturday",
      "opens": "08:00",
      "closes": "12:00"
    }
  ],
  "priceRange": "€€",
  "serviceType": ["Pose de carrelage", "Rénovation de salle de bain", "Douche italienne", "Faïence et mosaïque", "Carrelage extérieur"],
  "areaServed": {
    "@type": "GeoCircle",
    "geoMidpoint": {
      "@type": "GeoCoordinates",
      "latitude": 46.2304,
      "longitude": 7.4381
    },
    "geoRadius": "50000"
  }
};

const breadcrumbSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": [
    {
      "@type": "ListItem",
      "position": 1,
      "name": "Accueil",
      "item": "https://carreaux-bat.ch/"
    }
  ]
};

export default function Home() {
  return (
    <div className="min-h-screen">
      <SeoHead
        title="Carreaux-Bat Valais | Carreleur & Entreprise de Carrelage à Proximité"
        description="Vous cherchez un carreleur à proximité ? Entreprise de carrelage et société de carrelage basée à Grône, Valais. Service de carrelage par artisan carreleur près de chez vous à Sion, Sierre, Martigny, Crans-Montana, Verbier, Nendaz, Vercorin et Nax. Pose de carrelage, rénovation salle de bain, douche italienne. 20 ans d'expérience."
        keywords="carreleur à proximité Valais, entreprise de carrelage à proximité, société de carrelage à proximité, carreleur près de chez moi Valais, entreprise de carrelage près de chez vous, société de carrelage dans votre région, service de carrelage à proximité, carreleur Grône, carreleur Sion, carreleur Sierre, carreleur Martigny, carreleur Crans-Montana, carreleur Verbier, carreleur Nendaz, carreleur Vercorin, carreleur Nax, pose de carrelage Valais, carrelage Sion, carrelage Sierre, carrelage Martigny, carrelage Crans-Montana, carrelage Verbier, carrelage Nendaz, carrelage Vercorin, carrelage Nax, rénovation salle de bain Valais, douche italienne Valais, faïence mosaïque Valais"
        canonical="https://carreaux-bat.ch/"
        ogTitle="Carreaux-Bat Valais — Carrelage & Rénovation Salle de Bain à Proximité"
        ogDescription="Vous cherchez un carreleur à proximité ? Artisan carreleur en Valais. Pose de carrelage, rénovation salle de bain, douche italienne près de chez vous à Sion, Sierre, Martigny et toute la région."
        ogImage="/images/hero-1.jpg"
        geoPosition="46.2304;7.4381"
        geoPlacename="Grône, Valais, Suisse"
        geoRegion="CH-VS"
        schema={{
          "@context": "https://schema.org",
          "@graph": [localBusinessSchema, breadcrumbSchema]
        }}
      />
      <Navbar />
      {/* H1 sémantique pour SEO — nom de l'entreprise sur la home */}
      <h1 className="sr-only">Carreaux-Bat Valais — Entreprise de Carrelage & Carreleur en Valais, à Proximité de Sion, Sierre et Martigny</h1>
      <main>
        <HeroSection />
        <ServicesSection />
        <AboutSection />
        <LocalitiesSection />
        <FaqSection />
        <CtaSection />
      </main>
      <Footer />
    </div>
  );
}